module.exports = __webpack_public_path__ + "img/android.d08d662b.webp";